import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "mce-annotation tox-comment",
    "data-mce-annotation-uid": "mce-conversation_95621585221662750341026",
    "data-mce-annotation": "tinycomments"
  }, "What’s"),
  /*#__PURE__*/_createTextVNode(" your Document Management editing project?  ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center"} }, "Are you:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("table", {
  style: {"border-collapse":"collapse","width":"100%"},
  border: "1"
}, [
  /*#__PURE__*/_createElementVNode("colgroup", null, [
    /*#__PURE__*/_createElementVNode("col", { style: {"width":"50%"} }),
    /*#__PURE__*/_createElementVNode("col", { style: {"width":"50%"} })
  ]),
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"center"} }, [
        /*#__PURE__*/_createElementVNode("strong", null, [
          /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"36pt"} }, "📝"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Building a next-generation document creation solution")
        ]),
        /*#__PURE__*/_createTextVNode(" and want to offer the best rich text editing experience to your content creators? ")
      ]),
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center"} }, [
          /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"36pt"} }, [
            /*#__PURE__*/_createElementVNode("strong", null, "🗂️")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center"} }, [
          /*#__PURE__*/_createElementVNode("strong", null, "Developing an innovative documentation system"),
          /*#__PURE__*/_createTextVNode(" to organize, track, store, and share documents, and you want to add editing capabilities? ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createTextVNode(" Or perhaps it’s both? Then use the only WYSIWYG editor that’s trusted by "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://tiny.cloud",
    target: "_blank",
    rel: "noopener"
  }, "1.5M developers"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Curious about TinyMCE?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Play with this demo to see how TinyMCE works! Try out these popular document creation functions: ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Copy complex rich content from another app into the editor"),
  /*#__PURE__*/_createElementVNode("li", null, "Add or resolve a comment"),
  /*#__PURE__*/_createElementVNode("li", null, " Drag-and-drop an image from your computer, then edit it within TinyMCE "),
  /*#__PURE__*/_createElementVNode("li", null, " Insert {dynamic.content} into the document using Merge Tags (start typing \"\") "),
  /*#__PURE__*/_createElementVNode("li", null, " Any other functionality that you would expect in a document editor! ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Watch the video below to see how easy it is to get started (embedded in one click using "),
  /*#__PURE__*/_createElementVNode("em", null, "Enhanced Media Embed"),
  /*#__PURE__*/_createTextVNode("): ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  style: {"left":"0px","width":"100%","height":"0px","position":"relative","padding-bottom":"56.25%","max-width":"650px"},
  "data-ephox-embed-iri": "https://www.youtube.com/watch?v=_Pp1xnhQqec"
}, [
  /*#__PURE__*/_createElementVNode("iframe", {
    style: {"top":"0px","left":"0px","width":"100%","height":"100%","position":"absolute","border":"0px"},
    src: "https://www.youtube.com/embed/_Pp1xnhQqec?rel=0&controls=0",
    scrolling: "no",
    allowfullscreen: "allowfullscreen"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")!
  const _component_n_form_item = _resolveComponent("n-form-item")!

  return (_openBlock(), _createBlock(_component_n_form_item, {
    rule: {
      type: 'any',
      required: $props.required,
      message: $props.message,
      trigger: ['input', 'blur'],
    },
    label: $props.label,
    class: _normalizeClass('col-md-' + $props.col + '  mb-' + $props.mb),
    path: $props.path,
    "show-label": $props.ShowLabel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_editor, {
        modelValue: $setup.MyValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.MyValue) = $event)),
        "api-key": "wyy47pvqcho2nf6kivaczfl4kdvbcn8y5uyibh8xa35ddvyb",
        init: $setup.init,
        disabled: $props.disabled,
        onNodeChange: $setup.OpenModalUpdate,
        onKeyUp: $setup.OpenModalUpdate,
        onChange: $setup.OpenModalUpdate
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      }, 8, ["modelValue", "init", "disabled", "onNodeChange", "onKeyUp", "onChange"])
    ]),
    _: 1
  }, 8, ["rule", "label", "class", "path", "show-label"]))
}